import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import MoldMaintenanceAddEdit from './mold-maintenance-add-edit';
import { useDispatch, useSelector } from 'react-redux';
import { selectMoldMaintenanceRecordsData } from './store/selectors';
import { fetchMoldMaintenanceByToolId } from './store/slice';
import { ACTION_MODE } from '../../core/constants/constants';
import { MoldService } from 'Service/api/mold-service';
import { mapMaintenanceRecordSubmittedByFromApi } from './map-maintenance-api-fields';

// const initData = {
//     toolID: '',
//     moldDescription: '',
//     moldNumber: '',
//     lastMaintenanceDate: '',
//     maintenanceIntervalCycles: '',
//     currentMaintenanceDate: '',
//     maintenance_PerformedBy: '',
//   };

const MoldMaintenanceHistory = ({ onCloseModal, onActionClick, data }) => {
  const moldMaintenanceRecordsData = useSelector(selectMoldMaintenanceRecordsData);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchMoldMaintenanceByToolId(data.moldReceivingData.toolID));
  }, []);

  const handleViewRecord = async record => {
    const toolID = record.toolID;
    const id = record.maintenanceID || record.id;
    const response = await MoldService.getAllMoldMaintenanceByToolIdAndId(toolID, id);
    if (response && response.status === 200) {
      const raw = Array.isArray(response.response)
        ? response.response[0]
        : response.response;
      onActionClick(mapMaintenanceRecordSubmittedByFromApi(raw), ACTION_MODE.VIEW);
    } else {
      // handle error (optional)
    }
  };

  const handleAddRecord = () => {
    onActionClick({}, ACTION_MODE.ADD);
  };

  const columns = [
    { title: 'ToolID', dataIndex: 'toolID', key: 'toolID' },
    { title: 'Mold Description', dataIndex: 'moldDescription', key: 'moldDescription' },
    { title: 'Mold Number', dataIndex: 'moldNumber', key: 'moldNumber' },
    {
      title: 'Last Maintenance Date',
      dataIndex: 'lastMaintenanceDate',
      key: 'lastMaintenanceDate',
    },
    {
      title: 'Maintenance Interval Cycles',
      dataIndex: 'maintenanceIntervalCycles',
      key: 'maintenanceIntervalCycles',
    },
    {
      title: 'Current Maintenance Date',
      dataIndex: 'currentMaintenanceDate',
      key: 'currentMaintenanceDate',
    },
    {
      title: 'Maintenance Performed By',
      dataIndex: 'maintenance_PerformedBy',
      key: 'maintenance_PerformedBy',
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleViewRecord(record)}>
              View
            </Link>
          </div>
        </div>
      ),
    },
  ];
  return (
    <>
      <div className="mb-3">
        <button className="btn btn-info me-2 " onClick={() => handleAddRecord()}>
          + Add Maintenance Record
        </button>
      </div>

      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          {/* <Table columns={columns} dataSource={moldMaintenanceRecordsData} /> */}
          <Table
            columns={columns}
            dataSource={moldMaintenanceRecordsData}
            scroll={{ x: 'max-content' }} // enables horizontal scroll if content overflows
            pagination={{ pageSize: 5 }} // optional: keep it compact
          />
        </div>
      </div>
    </>
  );
};

MoldMaintenanceHistory.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.shape(CustomPropTypes.molds),
  onChanges: PropTypes.func,
};
export default MoldMaintenanceHistory;
